// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.scheduled_action_type_enum */
var ScheduledActionTypeEnum;
(function (ScheduledActionTypeEnum) {
    ScheduledActionTypeEnum["SAMPLE"] = "SAMPLE";
    ScheduledActionTypeEnum["OVERFLOW"] = "OVERFLOW";
    ScheduledActionTypeEnum["ADDITION"] = "ADDITION";
    ScheduledActionTypeEnum["WEIGHT"] = "WEIGHT";
    ScheduledActionTypeEnum["PROTOCOL_APPLY"] = "PROTOCOL_APPLY";
    ScheduledActionTypeEnum["HARVEST"] = "HARVEST";
    ScheduledActionTypeEnum["CUSTOM"] = "CUSTOM";
})(ScheduledActionTypeEnum || (ScheduledActionTypeEnum = {}));
;
export default ScheduledActionTypeEnum;
/** Zod schema for scheduled_action_type_enum */
export const scheduledActionTypeEnum = z.nativeEnum(ScheduledActionTypeEnum);
//# sourceMappingURL=ScheduledActionTypeEnum.js.map